import { render, staticRenderFns } from "./LotDetails.vue?vue&type=template&id=ca197e82"
import script from "./LotDetails.vue?vue&type=script&lang=js"
export * from "./LotDetails.vue?vue&type=script&lang=js"
import style0 from "./LotDetails.vue?vue&type=style&index=0&id=ca197e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports